import apiClientPdf from "@/shared/api/apiClientPdf";

export const generatePdfFromTipTap = async (id, payload) => {
  try {
    const response = await apiClientPdf.post("/generate-pdf/" + id, payload, {
      responseType: "blob",
    });
    return response;
  } catch (e) {
    console.error("generatePdfFromTipTap failed", e);
  }
};
